import React, { useRef, useState } from "react";
import { Container } from "react-bootstrap";
import "./template_01.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import { TENANT_BUCKET } from '../../common/constants';

const RankingList01 = ({ desktopToggle, mobileToggle }) => {
  const [swiperInstance, setSwiperInstance] = useState(null);
  const iframeRefs = useRef([]);
  const [clickedIndex, setClickedIndex] = useState(null); // track which video overlay was clicked

  if (!(desktopToggle || mobileToggle)) return null;

  const videos = ["jHmq4tpGhQg", "a5KStpsc-LQ"];

  // Pause all iframes except active
  const handleSlideChange = (swiper) => {
    const activeIndex = swiper.realIndex;
    iframeRefs.current.forEach((iframe, index) => {
      if (iframe && index !== activeIndex) {
        iframe.contentWindow.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          '*'
        );
      }
    });
  };

  // Stop autoplay when user clicks a video
  const handleVideoClick = (index) => {
    if (swiperInstance) swiperInstance.autoplay?.stop();
    setClickedIndex(index); // remove overlay immediately
    const iframe = iframeRefs.current[index];
    if (iframe) {
      // Send play command after overlay is removed
      iframe.contentWindow.postMessage(
        '{"event":"command","func":"playVideo","args":""}',
        '*'
      );
    }
  };

  return (
    <section
      className={`section ${!desktopToggle && "d-lg-none"} ${!mobileToggle && "d-none d-lg-block"}`}
      id="ranking_01"
    >
      <div className="rankingList_body">
        <Container>
          <div className="section_header">
            <div className="font_h2 section_title">
              <img src={`${TENANT_BUCKET}/icon/ranking_title_icon.png`} alt="" />
              Videos
            </div>
          </div>

          {/* Desktop */}
          <div className="d-none d-lg-flex flex-wrap justify-content-between" style={{ gap: "16px" }}>
            {videos.map((id, index) => (
              <div key={index} style={{ flex: "1 1 48%" }}>
                <iframe
                  ref={(el) => (iframeRefs.current[index] = el)}
                  width="100%"
                  height="270"
                  src={`https://www.youtube.com/embed/${id}?rel=0&modestbranding=1&controls=1&enablejsapi=1&autoplay=0`}
                  title="YouTube video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            ))}
          </div>

          {/* Mobile Swiper */}
          <div className="d-block d-lg-none">
            <Swiper
              modules={[Navigation, Autoplay]}
              navigation
              spaceBetween={16}
              slidesPerView={1}
              onSwiper={setSwiperInstance}
              onSlideChange={handleSlideChange}
              touchStartPreventDefault={false}
              simulateTouch={true}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
              }}
              loop={true}
            >
              {videos.map((id, index) => (
                <SwiperSlide key={index} style={{ position: "relative" }}>
                  {/* Only show overlay if video hasn’t been clicked */}
                  {clickedIndex !== index && (
                    <div
                      style={{
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        zIndex: 2,
                        cursor: "pointer",
                      }}
                      onClick={() => handleVideoClick(index)}
                    />
                  )}
                  <iframe
                    ref={(el) => (iframeRefs.current[index] = el)}
                    width="100%"
                    height="270"
                    src={`https://www.youtube.com/embed/${id}?rel=0&modestbranding=1&controls=1&enablejsapi=1&autoplay=0`}
                    title="YouTube video"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </Container>
      </div>
    </section>
  );
};

export default RankingList01;